import { MakeStringValues, Translations } from "../translations.type";

export const itTranslations: MakeStringValues<Translations> = {
  "Trascina qui un'immagine o clicca per caricarne una!":
    "Trascina qui un'immagine o clicca per caricarne una!",
  "Registra una nuova attivit\u00E1!": "Registra una nuova attivit\u00E1!",
  Annulla: "Annulla",
  Aggiungi: "Aggiungi",
  Banner: "Banner",
  Testi: "Testi",
  Orari: "Orari",
  "Banner dell'evento": "Banner dell'evento",
  Titolo: "Titolo",
  Contenuto: "Contenuto",
  "Data di inizio": "Data di inizio",
  "Fino al": "Fino al",
  "Crea Evento": "Crea Evento",
  Applica: "Applica",
  Nome: "Nome",
  Gestione: "Gestione",
  "Log out": "Esci",
  "Crea una promozione di benvenuto!": "Crea una promozione di benvenuto!",
  "Durata promozione": "Durata promozione",
  Anteprima: "Anteprima",
  Modifica: "Modifica",
  "Giorni alla scadenza": "Giorni alla scadenza",
  Crea: "Crea",
  "Ore alla scadenza": "Ore alla scadenza",
  "Minuti alla scadenza": "Minuti alla scadenza",
  Descrizione: "Descrizione",
  "Descrizione:": "Descrizione:",
  Salva: "Salva",
  "Data di fine": "Data di fine",
  Chiudi: "Chiudi",
  "Breve descrizione della promozione": "Breve descrizione della promozione",
  " Minuti": " Minuti ",
  " Giorni ": " Giorni ",
  " Ore ": " Ore ",
  Scadenza: "Scadenza",
  "Valida fino al giorno ": "Valida fino al giorno",
  "Qui ci sar\u00E1 la descrizione del tuo negozio, puoi modificarla nel pannello amministrativo!":
    "Qui ci sar\u00E1 la descrizione del tuo negozio, puoi modificarla nel pannello amministrativo!",
  Gestisci: "Gestisci",
  "filtra tipologia": "filtra tipologia",
  Tutte: "Tutte",
  Test: "Test",
  Produzione: "Produzione",
  "Invia una notifica": "Invia una notifica",
  "Nuova notifica": "Nuova notifica",
  "Messaggio notifica": "Messaggio notifica",
  "Codice di verifica": "Codice di verifica",
  "Conferma!": "Conferma!",
  "Registrandoti accetti i nostri": "Registrandoti accetti i nostri",
  "termini di servizio": "termini di servizio",
  "privacy policy": "privacy policy",
  "Iniziamo!": "Iniziamo!",
  "Sei gi\u00E1 registrato?": "Sei gi\u00E1 registrato?",
  Accedi: "Login",
  "Devices Subscribed And Reached": "Devices Subscribed And Reached",
  "Confirm code!": "Confirm code!",
  "Entra!": "Entra!",
  "Non hai ancora un account?": "Non hai ancora un account?",
  Registrati: "Registrati",
  "Come Funziona": "Come Funziona",
  Prezzi: "Prezzi",
  // HomePage
  "Fai crescere la tua attivit\u00E0 con Adhesion":
    "Fai crescere la tua attivit\u00E0 con Adhesion",
  "Richiama istantaneamente i tuoi clienti e offri loro le tue promozioni":
    "Richiama istantaneamente i tuoi clienti e offri loro le tue promozioni",
  "Inizia subito": "Inizia subito",
  // HeroSections
  "Notifica i tuoi clienti quando crei le tue promozioni":
    "Notifica i tuoi clienti quando crei le tue promozioni",
  "Adhesion sfrutta la tecnologia delle notifiche push per avvisare i tuoi clienti e offrire loro sconti e agevolazioni":
    "Adhesion sfrutta la tecnologia delle notifiche push per avvisare i tuoi clienti e offrire loro sconti e agevolazioni",
  "Raddoppia le vendite gi\u00E0 dal primo mese di utilizzo":
    "Raddoppia le vendite gi\u00E0 dal primo mese di utilizzo",
  "Adhesion \u00E8 un'app nativa in abbonamento senza vincoli di tempo adatta ad ogni tipo di attivit\u00E0 commerciale":
    "Adhesion \u00E8 un'app nativa in abbonamento senza vincoli di tempo adatta ad ogni tipo di attivit\u00E0 commerciale",
  "Parti col piede giusto": "Parti col piede giusto",
  "Adhesion \u00E8 in super promozionale iniziale e totalmente gratuito, ma non lo sar\u00E0 per sempre! Registrandoti ora diventerai un affiliato gratuito per sempre!":
    "Adhesion \u00E8 in super promozionale iniziale e totalmente gratuito, ma non lo sar\u00E0 per sempre! Registrandoti ora diventerai un affiliato gratuito per sempre!",
  // HowSection
  "Richiedi informazioni": "Richiedi informazioni",
  instruction1:
    "Registrati sul sito <1>a costo zero</1> e inizia subito a far scaricare l'app ai tuoi clienti.",
  instruction2:
    "Leggi il breve manuale di utilizzo e crea la tua base utenti. Segui il nostro <1>manuale di marketing</1> e sviluppa promozioni accattivanti per la tua clientela.",
  instruction3:
    "Analizza le <1>statistiche settimanali</1> di Adhesion per verificare quali promozioni sono state percepite come più interessanti dai tuoi clienti.",
  instruction4:
    "<1>Confronta il fatturato</1> della tua attivit\u00E0 prima e dopo l'utilizzo di Adhesion.",
  // ServicesSection
  "Piani mensili proposti": "Piani mensili proposti",
  mese: "mese",
  promos: "1 promozione a settimana",
  promos_plural: "{{count}} promozioni a settimana",
  devices: "1 dispositivo",
  devices_plural: "{{count}} dispositivi",
  notis: "1 notifica a settimana",
  notis_plural: "{{count}} notifiche a settimana",
  "Domande frequenti": "Domande frequenti",
  "Ti ricontatteremo subito": "Ti ricontatteremo subito",
  // Contact form
  Email: "Email",
  Telefono: "Telefono",
  "\u002AFacolatativo": "\u002AFacolatativo",
  "Voglio saperne di pi\u00F9": "Voglio saperne di pi\u00F9",
  // Others
  "Le tue attivit\u00E0": "Le tue attivit\u00E0",
  "\u00C8 disponibile una nuova versione!":
    "\u00C8 disponibile una nuova versione!",
  Aggiorna: "Aggiorna",
  "Sei attualmente offline. L'accesso all'applicazione potrebbe essere limitato.":
    "Sei attualmente offline. L'accesso all'applicazione potrebbe essere limitato.",
  "Torna online per scaricare nuovi dati":
    "Torna online per scaricare nuovi dati",
  Generali: "Generali",
  "Cerca tra i tuoi eventi con codice QR di attivazione":
    "Cerca tra i tuoi eventi con codice QR di attivazione",
  "Verifica codice QR": "Verifica codice QR",
  Eventi: "Eventi",
  "Centro Notifiche": "Centro Notifiche",
  Statistiche: "Statistiche",
  Profilo: "Profilo",
  Inizia: "Inizia",
};
